import React from "react";
import { EventButton } from "../common";

const ResultClosed = ({ wasCorrect = false, onGoHome }) => {
  return (
    <div className="newyear-result newyear-result--closed">
      <div className="newyear-result__icon">
        <span className="newyear-result__emoji">
          &#128683;
        </span>
      </div>

      <h2 className="newyear-result__title">선착순 마감</h2>

      {wasCorrect ? (
        <p className="newyear-result__message">
          정답을 맞추셨지만, 아쉽게도 선착순 마감되었습니다.
        </p>
      ) : (
        <p className="newyear-result__message">
          이벤트가 마감되었습니다.
        </p>
      )}

      <p className="newyear-result__sub-message">
        다음 이벤트에서 만나요!
      </p>

      {onGoHome && (
        <div className="newyear-result__actions">
          <EventButton
            variant="secondary"
            size="large"
            fullWidth
            onClick={onGoHome}
          >
            홈으로 돌아가기
          </EventButton>
        </div>
      )}
    </div>
  );
};

export default ResultClosed;
